import React, { useEffect, useState } from "react";
import Layout from "../Component/Layout";
import { Nav } from "react-bootstrap";
import {
  BiUser,
  BiLockAlt,
  BiCloudUpload,
  BiSolidHide,
  BiShow,
} from "react-icons/bi";
import Inputbox from "../Component/Inputbox";
// import Dummy from "../assets/Image/man.png";
import Button from "../Component/Button";
// import { useNavigate, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { showToast } from "../helper/Toster";
import REACT_APP_API_URL from "../utils/constant";
const REACT_APP_IMAGEPATH = process.env.REACT_APP_IMAGEPATH;
const Account = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Tab1");
  const [firstName, setFirstName] = useState("");
  const [fullName, setFullName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [previewImage, setPreviewImage] = useState();

  console.log(email);
  console.log(">>>>>>", fullName);

  // const [role,setRole] = useState('')
  const [bio, setBio] = useState("");
  const [image, setImage] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    password: "",
    newPassword: "",
    confirmPassword: "",
    firstName: "",
    fullName: "",
    email: "",
  });

  console.log(">>>>>>>>>>>image", previewImage);
  console.log(">>>>>>>>>>>>>>>password", image);

  // const params = useParams();
  useEffect(() => {
    getAdminDetails();
    setImage(previewImage + image);
    // handleImageUpload();
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    console.log(">>>>>>>file", file);
    if (file) {
      setImage(file); // Store the file
      setPreviewImage(URL.createObjectURL(file)); // Preview the image
    }
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   setImage(file);

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       setPreviewImage(e.target.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  //  "http://localhost:4000/data/adminImages/"
  const getAdminDetails = async () => {
    try {
      let result = await fetch(`${REACT_APP_API_URL}get-profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      });
      result = await result.json();
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>get", result);
      if (result) {
        setFirstName(result.data.first_name);
        setLastName(result.data.last_name);
        setFullName(result.data.full_name);
        setEmail(result.data.email);
        // setRole(result.role)
        setBio(result.data.bio);
        const imagePath = result.data.image;
        setImage(imagePath);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateProfile = async () => {
    try {
      const formData = new FormData();
      formData.append("first_name", firstName);
      // formData.append("last_name", lastName);
      formData.append("full_name", fullName);
      formData.append("email", email);
      formData.append("bio", bio);
      if (image) {
        formData.append("image", image);
      }
      console.log("Form data before upload:", formData);
      console.log("formData before appending to FormData:", formData);

      let result = await fetch(`${REACT_APP_API_URL}update-profile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
        body: formData,
      });
      console.log("formData before appending to FormData:", formData);

      result = await result.json();
      if (result && result.code === 200) {
        showToast("success", "Profile updated successfully");
        navigate("/account");
      } else {
        showToast("error", "Failed to update profile.");
        console.error(result); // Log error for debugging
      }

      result = await result.json();
      console.log(">>>>>>>>>>>>>>>result", result);
      if (result && result.code === 200) {
        showToast("success", "profile updated  successful!");
        navigate("/account");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updatePassword = async () => {
    if (newPassword !== confirmPassword) {
      showToast("error", "New password and confirm password do not match.!");
      return;
    }

    try {
      let result = await fetch(`${REACT_APP_API_URL}updatePassword`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
        body: JSON.stringify({
          password,
          newPassword,
        }),
      });
      result = await result.json();
      console.log("Password Update Result:", result);
      if (result && result.code === 200) {
        showToast("success", "Password updated  successfully.");
        navigate("/dashboard");
        setPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else if (result && result.code === 401) {
        showToast("error", "Current password not correct.");
      } else {
        showToast("error", "Failed to update password.");
      }
    } catch (err) {
      console.log(err);
      showToast("error", "Failed to update password.!");
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // const [uploadedImage, setUploadedImage] = useState(Dummy);
  // console.log(">>>>>>>>>>>>>>>>>>>>>>uploadedImage", uploadedImage);

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  const toggleNewPasswordVisibility = () => {
    setNewPasswordVisible(!isNewPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {
      password: "",
      newPassword: "",
      confirmPassword: "",
    };

    let hasError = false;

    if (!password) {
      newErrors.password = "Please enter your current password";
      hasError = true;
    } else if (password.trim() === "") {
      newErrors.password = "White spaces are not allowed.";
      hasError = true;
    }

    if (!newPassword || newPassword.trim() === "") {
      newErrors.newPassword = "Please enter your new password";
      hasError = true;
    } else if (newPassword.trim() === "") {
      newErrors.newPassword = "White spaces are not allowed.";
      hasError = true;
    }

    if (!confirmPassword || confirmPassword.trim() === "") {
      newErrors.confirmPassword = "Please enter your confirm password";
      hasError = true;
    } else if (confirmPassword.trim() === "") {
      newErrors.confirmPassword = "White spaces are not allowed.";
      hasError = true;
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirmPassword =
        "New password and confirm password does not match";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;
    updatePassword();
  };

  const UpdateProfile = (e) => {
    console.log("hiie");
    e.preventDefault();

    const newErrors = {
      // firstName: "",
      fullName: "",
      email: "",
    };

    let hasError = false;

    if (!fullName || fullName.trim() === "") {
      newErrors.fullName = "Please enter your full name";
      hasError = true;
    }

    if (email.trim() === "") {
      newErrors.email = "Please enter your email";
      hasError = true;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex
      const isValidate = emailRegex.test(email);
      if (!isValidate) {
        newErrors.email = "Please enter a valid email";
        hasError = true;
      }
    }

    setErrors(newErrors);
    if (hasError) return;

    updateProfile();
  };

  return (
    <Layout>
      <Nav variant="pills">
        <Nav.Item className="mb-3">
          <Nav.Link
            className={`w-auto me-2 ${activeTab === "Tab1" ? "active" : ""}`}
            onClick={() => handleTabClick("Tab1")}
          >
            <BiUser className="bx bx-sm me-1_5" />
            Account
          </Nav.Link>
          <Nav.Link
            className={`w-auto ${activeTab === "Tab2" ? "active" : ""}`}
            onClick={() => handleTabClick("Tab2")}
          >
            <BiLockAlt className="bx bx-sm me-1_5" />
            Change Password
          </Nav.Link>
        </Nav.Item>
      </Nav>

      {/* Tab Content */}
      <div className="tab-content p-0">
        <div className="card">
          <div className="card-body">
            {activeTab === "Tab1" && (
              <form onSubmit={UpdateProfile}>
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex align-items-center gap-sm-6 gap-2 pb-4 border-bottom">
                      <img
                        src={previewImage ? previewImage : image}
                        alt="user-avatar"
                        className="d-block w-px-100 h-px-100 rounded"
                        id="uploadedAvatar"
                        style={{ objectFit: "cover" }}
                      />
                      <div className="button-wrapper">
                        <label htmlFor="upload" className="btn btn-primary">
                          <span className="d-none d-sm-block">
                            Upload new photo
                          </span>
                          <BiCloudUpload className="bx d-block d-sm-none" />
                        </label>
                        <input
                          className="account-file-input"
                          id="upload"
                          type="file"
                          onChange={handleImageUpload} // Remove `value`
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mt-6">
                    <label
                      htmlFor="fname"
                      className="form-label fs-6 fw-semibold"
                    >
                      Full Name
                    </label>
                    <Inputbox
                      type="text"
                      className="form-control"
                      id="fname"
                      name="fname"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      placeholder="Enter full name"
                    />
                    {errors.fullName && (
                      <small className="text-danger">{errors.fullName}</small>
                    )}
                  </div>

                  {/* <div className="col-md-6 mt-6">
                    <label htmlFor="lname" className="form-label fs-6">
                      Last Name
                    </label>
                    <Inputbox
                      type="text"
                      className="form-control"
                      id="lname"
                      name="lname"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Enter last name"
                    />
                  </div> */}

                  <div className="col-12 mt-6">
                    <label
                      htmlFor="email"
                      className="form-label fs-6 fw-semibold"
                    >
                      Email
                    </label>
                    <Inputbox
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email"
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                  <div className="col-12 mt-6">
                    <label
                      htmlFor="bio"
                      className="form-label fs-6 fw-semibold"
                    >
                      Bio
                    </label>
                    <textarea
                      name=""
                      rows="6"
                      style={{ resize: "none" }}
                      value={bio}
                      onChange={(e) => setBio(e.target.value)}
                      placeholder="Tell about yourself"
                      className="form-control"
                      id=""
                    ></textarea>
                  </div>
                </div>
                <div className="mt-6">
                  <Button type="submit" className="px-5">
                    Save Changes
                  </Button>
                </div>
              </form>
            )}
            {activeTab === "Tab2" && (
              <div>
                <h5 className="card-header p-0 mb-4">Change Password</h5>
                <form onSubmit={handleSubmit}>
                  <div className="row ">
                    <div className="col-12 mb-6 ">
                      <div className="position-relative">
                        <label
                          htmlFor="oldpassword"
                          className="form-label fw-semibold"
                        >
                          Current Password
                        </label>
                        <Inputbox
                          type={isPasswordVisible ? "text" : "password"}
                          placeholder="Enter your current password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        {errors.password && (
                          <small className="text-danger">
                            {errors.password}
                          </small>
                        )}
                        <div
                          className="password-show position-absolute"
                          onClick={togglePasswordVisibility}
                        >
                          {isPasswordVisible ? <BiShow /> : <BiSolidHide />}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mb-6 ">
                      <div className="position-relative">
                        <label
                          htmlFor="newpassword"
                          className="form-label fw-semibold"
                        >
                          New Password
                        </label>
                        <Inputbox
                          type={isNewPasswordVisible ? "text" : "password"}
                          placeholder="Enter your new password"
                          className="form-control"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        {errors.newPassword && (
                          <small className="text-danger">
                            {errors.newPassword}
                          </small>
                        )}
                        <div
                          className="password-show position-absolute"
                          onClick={toggleNewPasswordVisibility}
                        >
                          {isNewPasswordVisible ? <BiShow /> : <BiSolidHide />}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mb-6 ">
                      <div className="position-relative">
                        <label
                          htmlFor="confirmpassword"
                          className="form-label fw-semibold"
                        >
                          Confirm Password
                        </label>
                        <Inputbox
                          type={isConfirmPasswordVisible ? "text" : "password"}
                          placeholder="Enter your confirm password"
                          className="form-control"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        {errors.confirmPassword && (
                          <small className="text-danger">
                            {errors.confirmPassword}
                          </small>
                        )}
                        <div
                          className="password-show position-absolute"
                          onClick={toggleConfirmPasswordVisibility}
                        >
                          {isConfirmPasswordVisible ? (
                            <BiShow />
                          ) : (
                            <BiSolidHide />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <Button type="submit" className="px-5">
                      Save Changes
                    </Button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Account;
